import { REQUEST_STATUS__PENDING, REQUEST_STATUS__SUCCESS } from '../../constants/other';

export const $isInitiateUpdateBookingRequestPending = state => {
  return state.CheckoutPage.initiateUpdateBookingRequestStatus === REQUEST_STATUS__PENDING;
};

export const $isInitiateUpdateBookingRequestSuccess = state => {
  return state.CheckoutPage.initiateUpdateBookingRequestStatus === REQUEST_STATUS__SUCCESS;
};
